import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <h1>Welcome to AnyVolt</h1>
          <p>Experience the future of EV charging with our innovative solutions.</p>
          <div className="cta-buttons">
            <a href="/download" className="btn-primary">Download App</a>
            <a href="/pricing" className="btn-secondary">View Pricing</a>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <h3>Easy Charging</h3>
              <p>Find and reserve EV charging stations with our intuitive app.</p>
            </div>
            <div className="feature-card">
              <h3>Fleet Management</h3>
              <p>Manage multiple EVs with our advanced scheduling tools.</p>
            </div>
            <div className="feature-card">
              <h3>Real-time Updates</h3>
              <p>Get live information on station availability and pricing.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;